import { ReactSVG } from "react-svg";
import { Column, ColumnTypes } from "ui/components/Table/TableSearch/types";
import { AdditionalEquipment } from "services/api/catalog/cvh/types";
import { FleetVehicleEquipmentItem } from "services/api/fleet/vehicles/equipment/types";
import { classNames } from "helpers";

/** Kolone tablice CVH prijedloga dodatne opreme (odabir po JOM-u). */
export const EQUIPMENT_SUGGESTION_COLUMNS: Column[] = [
  {
    title: "Naziv",
    type: ColumnTypes.custom,
    field: "name",
    render: (row: AdditionalEquipment) => (
      <div className={row.included ? "bg-green-50 -mx-4 -my-2 px-4 py-2" : ""}>
        <div className={classNames("font-medium uppercase", row.included ? "text-green-800" : "text-slate-900")}>{row.name}</div>
        <div className={classNames("text-sm max-w-[300px] overflow-hidden text-ellipsis line-clamp-2", row.included ? "text-green-600" : "text-slate-500")}>{row.description}</div>
      </div>
    ),
  },
  {
    title: "Cijena EUR",
    type: ColumnTypes.custom,
    field: "priceEur",
    render: (row: AdditionalEquipment) => (
      <div className={row.included ? "bg-green-50 -mx-4 -my-2 px-4 py-2 text-green-800" : ""}>
        {row.priceEur ? `${row.priceEur.toLocaleString("hr-HR")} €` : "-"}
      </div>
    ),
  },
  {
    title: "Konačna cijena EUR",
    type: ColumnTypes.custom,
    field: "finalPriceEur",
    render: (row: AdditionalEquipment) => (
      <div className={row.included ? "bg-green-50 -mx-4 -my-2 px-4 py-2 text-green-800" : ""}>
        {row.finalPriceEur ? `${row.finalPriceEur.toLocaleString("hr-HR")} €` : "-"}
      </div>
    ),
  },
];

/** Kolone tablice ručno dodane (vlastite) opreme. */
export const CUSTOM_EQUIPMENT_COLUMNS = (
  onRemove: (item: FleetVehicleEquipmentItem) => void
): Column[] => [
  {
    title: "Naziv",
    field: "name",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleEquipmentItem) => (
      <div>
        <div className="text-md font-medium text-slate-900 uppercase">{row.name}</div>
        {row.description && (
          <div className="text-sm max-w-[300px] overflow-hidden text-ellipsis line-clamp-2 text-slate-500">
            {row.description}
          </div>
        )}
      </div>
    ),
  },
  {
    title: "Cijena EUR",
    field: "priceEur",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleEquipmentItem) => (
      <div className="text-sm text-slate-900 truncate">
        {row.priceEur != null ? `${row.priceEur.toLocaleString("hr-HR")} €` : "-"}
      </div>
    ),
  },
  {
    title: "",
    field: "",
    type: ColumnTypes.custom,
    render: (row: FleetVehicleEquipmentItem) => (
      <div
        onClick={() => onRemove(row)}
        className="flex justify-end items-center h-[30px] cursor-pointer"
      >
        <ReactSVG src={"/media/icons/trash.svg"} className="w-4 h-4 stroke-[#bd0000]" />
      </div>
    ),
  },
];
